import { render } from "./PriceListSupplierCompareDialog.vue?vue&type=template&id=40fb6a46&scoped=true"
import script from "./PriceListSupplierCompareDialog.vue?vue&type=script&lang=js"
export * from "./PriceListSupplierCompareDialog.vue?vue&type=script&lang=js"

import "./PriceListSupplierCompareDialog.vue?vue&type=style&index=0&id=40fb6a46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fb6a46"]])

export default __exports__